// routes
import { PATH_DASHBOARD } from './routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API_KEY = import.meta.env.VITE_HOST_API_KEY || '';

export const FIREBASE_API = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  appId: import.meta.env.VITE_FIREBASE_APPID,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
};

export const COGNITO_API = {
  clientId: import.meta.env.VITE_AWS_COGNITO_CLIENT_ID,
  userPoolId: import.meta.env.VITE_AWS_COGNITO_USER_POOL_ID,
};

export const AUTH0_API = {
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
};

export const MAP_API = import.meta.env.VITE_MAPBOX_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.home;

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  H_DASHBOARD_DESKTOP: 92,
  H_DASHBOARD_DESKTOP_OFFSET: 92 - 32,
  H_MAIN_DESKTOP: 88,
  H_MOBILE: 64,
};

export const NAV = {
  //
  H_DASHBOARD_ITEM: 48,

  //
  H_DASHBOARD_ITEM_HORIZONTAL: 32,

  H_DASHBOARD_ITEM_SUB: 36,

  W_BASE: 260,

  W_DASHBOARD: 280,

  W_DASHBOARD_MINI: 88,
};

export const ICON = {
  NAV_ITEM: 24,
  NAV_ITEM_HORIZONTAL: 22,
  NAV_ITEM_MINI: 22,
};
